import React, { useEffect } from "react";
import { getPosts, getMorePosts, selectAfter, selectPosts } from "./postsSlice";
import { useDispatch, useSelector } from "react-redux";
import "./Post.css";
import Card from "../../components/card/Card";
import { useParams } from "react-router-dom";

export default function Posts() {
  const dispatch = useDispatch();
  const posts = useSelector(selectPosts);
  const after = useSelector(selectAfter);

  let params = useParams();

  useEffect(() => {
    dispatch(getPosts(`r/${params.subreddit}`));
  }, [dispatch, params]);

  const loadMoreData = () => {
    dispatch(getMorePosts(after));
  };

  return (
    <>
      {posts.map((outerEl) =>
        outerEl.data.children
          .filter((post) => !post.data.over_18)
          .map((post) => (
            <Card key={post.data.id} post={post} className="card" />
          ))
      )}

      <button className="btn btn-success center" onClick={loadMoreData}>
        Grab More Posts
      </button>
    </>
  );
}
